import { lazy, Suspense, useEffect, useState } from 'react';
import { Route, Routes, Navigate, useLocation } from 'react-router-dom';
import Markup from './jsx'; // Import dashboard layout
import './vendor/bootstrap-select/dist/css/bootstrap-select.min.css';
import './css/style.css';

// Lazy-loaded pages
const Login = lazy(() => import('./jsx/pages/Login'));
const SignUp = lazy(() => import('./jsx/pages/Registration'));
const ForgotPassword = lazy(() => import('./jsx/pages/ForgotPassword'));

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const location = useLocation();

  // Function to check if the user is authenticated
  const checkAuth = () => {
    const token = localStorage.getItem('token');
    return !!token; // Convert to boolean (true if token exists)
  };

  // Set auth state on mount and when localStorage changes
  useEffect(() => {
    setIsAuthenticated(checkAuth());
  }, [location.pathname]); // Runs when route changes

  useEffect(() => {
    const intervalId = setInterval(() => {
      window.location.reload(); // Reload the page every 20 minutes
    }, 1200000); // 1200000 ms = 20 minutes
  
    return () => clearInterval(intervalId);
  }, []);
  

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Routes>
        {isAuthenticated ? (
          <>
            <Route path="/dashboard/*" element={<Markup />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </>
        ) : (
          <>
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </>
        )}
      </Routes>
    </Suspense>
  );
}

export default App;
